import { createFileRoute } from "@tanstack/react-router";
import { LivePortalPage } from "@/components/shared/LivePortalPage";
export const Route = createFileRoute("/portal.payments")({ component: Page });
function Page() {
  return (
    <LivePortalPage
      title="Payments"
      description="Live data from your KIZAK account."
      table="payments"
      filterField="customer_id"
      columns={[
        { key: "provider", label: "Provider" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
